import React from "react";
import HamzaIcon from "../../assets/images/hamzaicon.png"

export default function AboutPageBanner() {
  return (
    <div className="header-content py-24 dark:bg-content flex items-center justify-center dark:text-white">
      <div className="grid md:grid-cols-2 gap-10 w-11/12 lg:w-9/12">
        <div className="flex flex-col justify-center">
          <h1 className="text-4xl lg:text-6xl font-bold">
            Discover, explore, and get to know more about{" "}
            <span className="text-sky-800 dark:text-sky-500">
              {" "}
              GDSC UIT
            </span>
          </h1>
          <p className="mt-3 text-xl">
            GDSC is one of the most active and fastest growing community
          </p>
        
        </div>
        <div>
          <a
            rel="noreferrer"
            className="flex items-center justify-center"
          >
            <div className="lg:w-11/12 rounded-3xl dark:bg-primary transition-all  shadow-sky-500/25 shadow-2xl">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/gdscuit.appspot.com/o/Pink%20Gradient%20Marketing%20Masterclass%20LinkedIn%20Post%20(1).png?alt=media&token=0a57619c-e1de-421b-ae86-6d41d14f231a"
                alt=""
                className="rounded-3xl w-full"
              />
              <div className="flex items-center w-full p-5 ">
                <img
                  src={HamzaIcon}
                  alt=""
                  className="h-10 w-10 rounded-full mr-2"
                />
                <div>
                  <h1 className="">GDSC UIT</h1>
                  <p className="text-sm">by Syed Hamza Hoda</p>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
